import React from "react";
import './Reference.scss';
import lang from '../../i18/lang';
import img_05 from "../../assets/reference/05.png";
import img_06 from "../../assets/reference/06.png";
import img_08 from "../../assets/reference/08.png";
import img_10 from "../../assets/reference/10.png";
import img_02 from "../../assets/reference/02.png";
import img_03 from "../../assets/reference/03.png";

class Reference extends React.Component {
    render(){
        return (
            <div id="reference" className="reference-wrapper" ref={this.props.ref_reference}>
                <p>{lang.srb.section.reference.reference}</p>
                <h1>{lang.srb.section.reference.za_koga_smo_radili}</h1>
                <div className="reference-list">
                    <div className="reference-item">
                        <img src={img_05} alt=""/>
                    </div>
                    <div className="reference-item">
                        <img src={img_06} alt=""/>
                    </div>
                    <div className="reference-item">
                        <img src={img_08} alt=""/>
                    </div>
                    <div className="reference-item">
                        <img src={img_10} alt=""/>
                    </div>
                    <div className="reference-item">
                        <img src={img_02} alt=""/>
                    </div>
                    <div className="reference-item">
                        <img src={img_03} alt=""/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Reference;